export default __webpack_public_path__ + "static/media/beep-logo.5be49261.png";